import { defineChain } from 'viem';

import { getContrastColor } from '@infinex/ui-utils/color';

import { envOverrides } from '../../env';
import {
  DEFAULT_CHAIN_LIMITS,
  defaultServices,
  defaultSwidge,
} from '../configHelpers';
import type { AllChainConfig } from '../configTypes';

const viemMonad = /*#__PURE__*/ defineChain({
  id: 143,
  name: 'Monad',
  nativeCurrency: {
    decimals: 18,
    name: 'Monad',
    symbol: 'MON',
  },
  contracts: {
    multicall3: {
      address: '0xcA11bde05977b3631167028862bE2a173976CA11',
      blockCreated: 9248132,
    },
  },
  rpcUrls: {
    default: { http: ['https://rpc.monad.xyz'] },
  },
  blockExplorers: {
    default: {
      name: 'Monad Explorer',
      url: 'https://monvision.io',
    },
  },
  testnet: false,
});

export const monad = {
  displayName: 'Monad',
  runtime: 'evm',
  viemChain: viemMonad,
  isSupported: true,
  isReleased: true,
  isMainnet: true,
  orderPriority: 3, //todo: confirm order priority

  decoration: {
    color: '#6E54FF',
    get contrastColor() {
      return getContrastColor(this.color);
    },
  },
  features: {
    wallet: {
      supported: true,
      import: true,
      eip7702: true,
      defaultKind: 'EOA',
      autoUpgradeSCA: true,
    },
    vault: {
      supported: false,
      ccqRecovery: false,
    },
  },
  connectivity: {
    rpc: {
      quicknode: {
        chainKey: 'monad-mainnet',
      },
    },
    blockExplorers: {
      primary: {
        base: 'https://monvision.io',
        token: 'https://monvision.io/token',
      },
    },
  },
  environments: {
    prod: true,
    staging: true,
    test: true,
    dev: true,
  },
  swidge: defaultSwidge({}),
  services: defaultServices({
    codex: {
      networkId: 143,
      nativeLiquidityAddress: '0x3bd359C1119dA7Da1D913D1C4D2B7c461115433A',
    },
    defiLlama: { chainKeys: ['monad'] },
    // trm: { chainKey: 'monad' },
    coingecko: {
      networkId: 'monad',
      platformId: 'monad',
    },
    coingeckoDex: {
      networkId: 'monad',
    },
    zerion: {
      chainKey: 'monad',
    },
    qnStreams: {
      networkKey: 'monad-mainnet',
    },
    safe: { shortName: 'monad' },
    alchemy: { chainSlug: 'monad-mainnet' },
    pimlico: { chainSlug: 'monad' },
  }),
  limits: envOverrides(DEFAULT_CHAIN_LIMITS, {
    test: {
      minUsdWithdrawalAmount: 0,
    },
    dev: {
      minUsdWithdrawalAmount: 0,
    },
  }),
} as const satisfies AllChainConfig<'evm', true>;
